export const FEATURES = [
  {
    value: 'air_conditioning',
    labelKey: 'search.filter.air_conditioning',
    tracking: 'ga-search-form-air_conditioning',
    cy: 'features-air-conditioning'
  },
  {
    value: 'heating',
    labelKey: 'search.filter.heating',
    tracking: 'ga-search-form-heating',
    cy: 'features-heating'
  },
  {
    value: 'washing_machine',
    labelKey: 'search.filter.washingMachine',
    tracking: 'ga-search-form-washing_machine',
    cy: 'features-washing-machine'
  },
  {
    value: 'oven',
    labelKey: 'search.filter.oven',
    tracking: 'ga-search-form-oven',
    cy: 'features-oven'
  },
  {
    value: 'dishwasher',
    labelKey: 'search.filter.dishwasher',
    tracking: 'ga-search-form-dishwasher',
    cy: 'features-dishwasher'
  },
  {
    value: 'withDesk',
    labelKey: 'search.filter.with_desk',
    tracking: 'ga-search-form-withDesk',
    cy: 'features-with-desk'
  },
  {
    value: 'balcony',
    labelKey: 'search.filter.balcony',
    tracking: 'ga-search-form-balcony',
    cy: 'features-balcony'
  },
  {
    value: 'elevator',
    labelKey: 'search.filter.elevator',
    tracking: 'ga-search-form-elevator',
    cy: 'features-elevator'
  }
];
